import Script from "src/component/script/Script";
import { IInfo } from "../ExecScript";
import { IGuiData } from "../IExecConfig";

/**
 *
 *
 * @class Handle
 */
class Handle {
    script: Script<any>;

    updataSource: (state?: any) => void;

    protected nextIds: string[];

    protected nodeId: string;

    protected ret: any;

    protected data: IGuiData | undefined;

    protected execItem: (id: string, info?: IInfo, parentId?: string) => void;

    protected execEdge: (id: string, info?: IInfo) => boolean;

    constructor(script: Script<any>, updataSource: () => void = () => { }, data?: IGuiData) {
        this.script = script;
        this.updataSource = updataSource;
        this.data = data;
    }

    setNext(ids: string[] = [], execItem: any, execEdge: any, nodeId: string, ret: any) {
        this.nextIds = ids;
        this.execItem = execItem;
        this.execEdge = execEdge;
        this.nodeId = nodeId;
        this.ret = ret;
    }

    /**
     * 执行下一步
     */
    protected execNext(info?: IInfo) {
        this.nextIds.map(id => {
            let to = info;
            if (to) to = { ...to };
            this.execItem(id, to, this.nodeId);
        });
    }

    exec(info: IInfo, parentId?: string, execFinish?: any) {
        if (this.script.exec(info, this.execNext.bind(this))) {
            execFinish?.();
            //如果执行结果没有返回结束，则继续执行下一步
            this.execNext(info);
        } else {
            execFinish?.();
        }
    }
}

export default Handle;
